module.exports = __webpack_public_path__ + "img/sample-portal-home.38151ef7.svg";